// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgFolder24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_6830_376178)">
					<path d="M20.8254 8.02172V6.67777C20.8254 6.59713 20.8343 5.90724 20.3415 5.4055C20.1265 5.1815 19.7233 4.91271 19.0782 4.91271L9.572 4.82312C9.15985 4.53641 8.64019 4.29449 8.00405 4.29449H3.89156C2.69096 4.28554 1.71436 5.26214 1.71436 6.46274V17.1158C1.71436 18.3164 2.69096 19.293 3.89156 19.293H20.1086C21.3092 19.293 22.2858 18.3164 22.2858 17.1158V9.98389C22.2858 9.27608 21.8826 8.27259 20.8254 8.02172ZM19.4814 6.65089V7.95901H12.7796C12.2868 7.95901 11.8298 7.52894 11.7134 7.39455L10.8174 6.16707L19.0782 6.24771C19.2216 6.24771 19.4814 6.24771 19.4814 6.65089ZM20.9418 17.1158C20.9418 17.5727 20.5655 17.9491 20.1086 17.9491H3.89156C3.43461 17.9491 3.05831 17.5727 3.05831 17.1158V6.46274C3.05831 6.00579 3.43461 5.62949 3.89156 5.62949H8.01301C8.84626 5.62949 9.42864 6.54338 9.46448 6.59713L10.6472 8.21884C10.7368 8.32635 11.561 9.31192 12.7796 9.31192H20.2967C20.8074 9.31192 20.9239 9.67926 20.9329 9.98389V17.1158H20.9418Z" />
				</g>
				<defs>
					<clipPath id="clip0_6830_376178">
						<rect width={20.5714} height={15.0075} transform="translate(1.71436 4.28564)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgFolder24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgFolder24;
